import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id A3CC4F14-35C0-421B-A818-9B8E4E852522
 * name vector-point-edit
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point-edit.svg
 * tags
 * - Vector 
 * - Edit / Modify 
 */
export const VectorPointEditIcon = createSvgIcon(<><path d="M9 9V15H15V9H9M11 11H13V13H11V11M21.2 13C21.1 13 20.9 13.1 20.8 13.2L19.8 14.2L21.9 16.3L22.9 15.3C23.1 15.1 23.1 14.7 22.9 14.5L21.6 13.2C21.4 13.1 21.3 13 21.2 13M19.1 14.8L13 20.9V23H15.1L21.2 16.8L19.1 14.8Z" /></>, 'VectorPointEditIcon');
export default VectorPointEditIcon